import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static values = {
    questionId: Number
  };

  declare questionIdValue: number;

  async sort(event: Event): Promise<void> {
    event.preventDefault();

    const button = event.currentTarget as HTMLButtonElement;
    const { column, direction, turboFrame } = button.dataset;

    if (!column || !direction || !turboFrame) {
      console.error('[question-results] Missing required data attributes');
      return;
    }

    const frame = document.getElementById(turboFrame);
    if (!frame) {
      console.error(`[question-results] Frame not found: ${turboFrame}`);
      return;
    }

    // Preserve scroll position
    const scrollY = window.scrollY;

    // Build URL with updated sort params
    const url = new URL(window.location.href);
    url.searchParams.set(`question_${this.questionIdValue}_sort_column`, column);
    url.searchParams.set(`question_${this.questionIdValue}_sort_direction`, direction);

    // Set loading state
    frame.setAttribute('aria-busy', 'true');

    try {
      const response = await fetch(url.toString(), {
        headers: { 'Turbo-Frame': turboFrame }
      });

      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const html = await response.text();

      // Parse response and extract matching frame
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');
      const newFrame = doc.getElementById(turboFrame);

      if (newFrame) {
        frame.innerHTML = newFrame.innerHTML;
      } else {
        console.warn(`[question-results] New frame not found in response: ${turboFrame}`);
      }

      // Update URL without triggering navigation
      window.history.replaceState({}, '', url.toString());
    } catch (error) {
      console.error('[question-results] Failed to sort results:', error);
      // Optionally show user-friendly error message
    } finally {
      frame.removeAttribute('aria-busy');
      // Restore scroll position
      window.scrollTo(0, scrollY);
    }
  }
}
